
import { z } from "zod";

export const TaskReadinessValues = ["READY", "SCHEDULED", "BLOCKED", "COMPLETE", "CANCELED", "PARKED"] as const;
export const TaskReadinessSchema = /* @__PURE__ */ z.enum(TaskReadinessValues);
export const TaskReadiness: (typeof TaskReadinessSchema)["enum"] = { "READY": "READY", "SCHEDULED": "SCHEDULED", "BLOCKED": "BLOCKED", "COMPLETE": "COMPLETE", "CANCELED": "CANCELED", "PARKED": "PARKED" };
export type TaskReadiness = (typeof TaskReadinessValues)[number];
